import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Map, GoogleApiWrapper } from 'google-maps-react';
import { Icon } from 'semantic-ui-react'

const LoadingContainer = (props) => (
  <Icon loading name='spinner' size='huge' />
)

export class MapContainer extends Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
  };

  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

  getStateAndHelpers() {
    return {
      showingInfoWindow: this.state.showingInfoWindow,
      activeMarker: this.state.activeMarker,
      selectedPlace: this.state.selectedPlace,
      onMarkerClick: this.onMarkerClick,
      onMapClicked: this.onMapClicked,
      google: this.props.google
    }
  }

  render() {
    return (
      <Map
        google={this.props.google}
        zoom={this.props.zoom || 14}
        style={this.props.style}
        initialCenter={!!this.props.initialCenter && {
            lat: this.props.initialCenter.latitude,
            lng: this.props.initialCenter.longitude
        }}
        center={!!this.props.initialCenter && {
            lat: this.props.initialCenter.latitude,
            lng: this.props.initialCenter.longitude
        }}
        onClick={this.onMapClicked}>
        {this.props.children(this.getStateAndHelpers())}
      </Map>
    );
  }

  static propTypes = {
    zoom: PropTypes.number,
    style: PropTypes.object,
    initialCenter: PropTypes.object
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyA2WpUZSFC101-mkth7Ue7aZJzAlZNUOGs',
  LoadingContainer: LoadingContainer
})(MapContainer)



// WEBPACK FOOTER //
// ./src/maps/Map.js